import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { APP_IMG, APP_URL, SHOW_COMMEMORATE } from 'src/constants';
import client from 'src/utils/client';
import Layout from 'src/components/layouts';
import PageError from 'pages/404';

import parse from 'html-react-parser';
import { GET } from 'src/utils/services';
import { useDesktop } from 'src/utils/device';
import _ from 'lodash';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import useUser from 'src/utils/useUser';

const PageLazada = ({ articles, dataAdsHeader }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (!articles) return <PageError dataAdsHeader={dataAdsHeader} sessionSevId={sessionSevId} />;
  return (
    <>
      <NextSeo
        noindex={true}
        nofollow={true}
        title={articles?.title}
        description={articles?.description}
        robotsProps={{
          maxImagePreview: 'large',
          maxSnippet: -1,
          maxVideoPreview: -1
        }}
      />
      <Head>
        <link rel='canonical' href={`${APP_URL}/lazada`} />
        {/* ----------------------------- ScriptBrowser ------------------------------------ */}
        {!useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}
        {/* ----------------------------- ADS : PPN ------------------------------- */}
        <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
          }}
        />
        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                __th_page="lazada";
              `
          }}
        />
      </Head>
      <Layout sessionSevId={sessionSevId}>
        <div className='lazada-page'>
          <section className='lazada-top' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
            <a href={articles?.urlAll} target='_blank' className='container lazada-logo' rel={'noopener noreferrer nofollow'}>
              <img src={`${APP_IMG}/static/lazada/lazada-logo.svg`} alt='lazada-logo' width='100%' />
            </a>
            <a
              href={articles?.urlAll}
              target='_blank'
              className='lazada-banner'
              rel={'noopener noreferrer nofollow'}
              //! DATALAYER
            >
              <img src={`${APP_IMG}/${articles?.bannerDesktopImage}`} alt={articles?.altBannerDesktop} className='desktop' width='100%' />
              <img src={`${APP_IMG}/${articles?.bannerMobileImage}`} alt={articles?.altBannerMobile} className='mobile' width='100%' />
            </a>
          </section>

          <section className='lazada-list' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
            <div className='container'>
              <h4 className='lazada-list-h '>ช้อปครั้งนี้ มีแต่ได้กับได้</h4>
              <ul className='lazada-ul-list'>
                {articles?.banner1.length > 0 &&
                  articles.banner1.map((item, i) => (
                    <li key={i}>
                      <a
                        href={item.url || '#'}
                        target='_blank'
                        rel={'noopener noreferrer nofollow'}
                        //! DATALAYER
                      >
                        <img src={`${APP_IMG}/${item.image}`} alt={item.alt} width='100%' />
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
            <div className='btn-lazada'>
              <a href={articles?.urlAll} target='_blank' rel={'noopener noreferrer nofollow'}>
                ดูสินค้าทั้งหมด
              </a>
            </div>
          </section>
        </div>
      </Layout>
    </>
  );
};

export async function getServerSideProps() {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    articles: null,
    dataAdsHeader: null
  };

  try {
    const { data } = await client.fetch.get('api/sale-pages/lazada');
    if ('msg' in data) {
      initProps.articles = null;
    } else {
      initProps.articles = data;
    }
    const scriptBrowser = await GET('/api/headerAds');
    if (!_.isEmpty(scriptBrowser)) {
      initProps.dataAdsHeader = scriptBrowser || '';
    }
  } catch (err) {
    console.log('============> LAZADA ERROR', err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
}

export default PageLazada;
